import React, { Component } from 'react';
import theme from '../../app.theme';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Youtube from 'react-youtube';
import { Card } from '../../components';
import renderHTML from 'react-render-html';
import { DefaultPlayer as HTML5Player } from 'react-html5video';
import 'react-html5video/dist/styles.css';

class LearningContent extends Component {

  extractVideoIdFromYoutubeUrl(url) {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[7].length == 11) ? match[7] : false;
  }

  renderVideo(url) {
    const opts = {
      height: '330',
      width: '100%',
      playerVars: {
        showinfo: 0,
        rel: 0,
      },
    };
    const youtubeVideoId = this.extractVideoIdFromYoutubeUrl(url);
    return youtubeVideoId
    ? (
      <Youtube
        videoId={youtubeVideoId}
        opts={opts}
      />
    )
    : (
      <HTML5Player
        controls={['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen']}
      >
        <source src={url} type="video/mp4" />
      </HTML5Player>
    );
  }

  getSource(block) {
    try {
      return JSON.parse(block.content).url;
    } catch (e) {
    }

    return null;
  }

  renderBlocks() {
    const contentStyle = {
      fontSize: '14px',
    };
    return this.props.content.blocks.asMutable().map((block) => {
      if (block.type == 0) {
        return (
          <CardMedia key={block.id}>
            <div dangerouslySetInnerHTML={{ __html: block.content }} key={block.id} />
          </CardMedia>
        );
      }

      if (block.type == 2) {
        const src = this.getSource(block);

        if (!src) {
          return null;
        }
        return (
          <CardMedia key={block.id}>
            <div style={{ maxHeight: 380, marginBottom: 20, marginTop: 10, textAlign: 'center', backgroundColor: '#f8f8f8' }}>
              <img key={block.id} src={src} style={{ maxWidth: '100%', maxHeight: 380 }} />
            </div>
          </CardMedia>
        );
      }
      if (block.type == 3) {
        return (
          <CardMedia key={block.id} style={{ paddingBottom: 20, maxHeight: 380 }}>
            {this.renderVideo(block.content)}
          </CardMedia>
        );
      }

      if (block.type == 1) {
        return (
          <CardMedia key={block.id}>
            <h3 style={{ margninTop: 0, '-webkit-margin-before': 0 }}>{block.content}</h3>
          </CardMedia>
        );
      }

      // type 1 and default is text
      return <CardContent style={contentStyle}>{block.content}</CardContent>;
    });
  }
  render() {
    if (!this.props.content) {
      return null;
    }

    return (
      <Card title={this.props.content.title} showAll={this.props.showAll}>
        {this.renderBlocks()}
      </Card>
    );
  }
}

export default LearningContent;



// WEBPACK FOOTER //
// ./src/app/main/course/learning-content.js